import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [currentOutlet, setCurrentOutlet] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem('serveos_token');
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data.user);
      setTenant(data.tenant);
      setOutlets(data.outlets || []);
      setPermissions(data.permissions || []);
      const savedOutlet = localStorage.getItem('serveos_outlet');
      const outlet = (data.outlets || []).find((o) => o.id === savedOutlet) || (data.outlets || [])[0];
      setCurrentOutlet(outlet || null);
    } catch (e) {
      localStorage.removeItem('serveos_token');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = async (token) => {
    localStorage.setItem('serveos_token', token);
    setLoading(true);
    await loadMe();
  };

  const logout = () => {
    localStorage.removeItem('serveos_token');
    localStorage.removeItem('serveos_outlet');
    setUser(null); setTenant(null); setOutlets([]);
    window.location.href = '/login';
  };

  const selectOutlet = (o) => {
    setCurrentOutlet(o);
    localStorage.setItem('serveos_outlet', o.id);
  };

  const can = (perm) => user?.is_platform_admin || permissions.includes('*') || permissions.includes(perm);

  return (
    <AuthContext.Provider value={{ user, tenant, outlets, permissions, currentOutlet, loading, login, logout, selectOutlet, can, reload: loadMe }}>
      {children}
    </AuthContext.Provider>
  );
};
